import React, { useContext, useState } from "react";
import "./RenameProject.css";
import { TbStack2 } from "react-icons/tb";
import { useLanguage } from "../../../../LanguageProvider";
import AddModalInputField from "../../../../components/AddModalInputField/AddModalInputField";
import { useToaster } from "../../../../ToasterProvider";
import { GeneralContext } from "../../../../GeneralProvider";

export default function RenameProject() {
  const { selectedProjectTitle, selectedProjectID, handleUpdateProjectTitle } =
    useContext(GeneralContext);
  const { toastWarning } = useToaster();
  const { getTranslation } = useLanguage();
  const [title, setTitle] = useState(selectedProjectTitle);

  const handleRename = () => {
    if (title.trim() === "") {
      toastWarning(getTranslation("titleCantBeEmpty"));
      return;
    }
    handleUpdateProjectTitle(selectedProjectID, title);
    setTitle("");
  };

  return (
    <div className="rename-project-container">
      <p className="rename-project-title">{getTranslation("rename")}</p>

      <AddModalInputField
        icon={<TbStack2 size={22} style={{ width: "25px" }} />}
        placeholder={getTranslation("title") + "*"}
        value={title}
        onChange={(e) => setTitle(e.target.value)}
        type={"text"}
      />

      <div className="rename-project-actions">
        <button className="rename-project-button create" onClick={handleRename}>
          {getTranslation("rename")}
        </button>
      </div>
    </div>
  );
}
